import { routeTypes } from "../hooks/useSystemRoutes"

import SystemLogo from "../components/@layouts/SystemLogo"

import { customSystemLogoConfigs } from '../customization'

export const logoTypes = {
  login: "login",
  sidebar: "sidebar"
}

export const getSystemLogo = ({ routeType, logoType }) => {

  let LogoComponent = <SystemLogo routeType={routeType} logoType={logoType} />

  if(customSystemLogoConfigs?.enabled){
    LogoComponent = customSystemLogoConfigs.component({ routeType, logoType })
  }

  return {
    isCustom: customSystemLogoConfigs?.enabled,
    component: LogoComponent
  }
}